import { BoolStringShort } from "../../types";
import { Catalog, CatalogItem } from "./common";

export type ChlorineSensorCatalog = Catalog & {
    chlorineSensors: ChlorineSensorCatalogItem[];
}

export enum ChlorineSensorSensorTypes {
    TOTAL_CHLORINE = "TOTAL_CHLORINE",
    FREE_CHLORINE = "FREE_CHLORINE",
}

export type ChlorineSensorCatalogItem = CatalogItem & {
    sensorType: ChlorineSensorSensorTypes,
    /** Introduced by CatalogVersion v42 */
    supportGainControl?: BoolStringShort,
};

export enum ChloirneSensorGains {
    Auto = "Auto",
    ZERO_TO_160_PPM = "ZERO_TO_160_PPM",
    ZERO_TO_80_PPM = "ZERO_TO_80_PPM",
    ZERO_TO_40_PPM = "ZERO_TO_40_PPM",
    ZERO_TO_20_PPM = "ZERO_TO_20_PPM",
    ZERO_TO_10_PPM = "ZERO_TO_10_PPM",
    ZERO_TO_5_PPM = "ZERO_TO_5_PPM",
    ZERO_TO_2_PPM = "ZERO_TO_2_PPM",
    ZERO_TO_1_PPM = "ZERO_TO_1_PPM",
}
